<div
  class="group"
  [ngClass]="{
    group_column: !props.inlineGroup,
    group_inline: props.inlineGroup,
    'group_full-width': props.isFullWidth
  }"
  [style.gridTemplateRows]="
    'var(--form-group-template-rows, ' +
    (props.groupTemplateRows || 'unset') +
    ')'
  "
  [style.gridTemplateColumns]="
    'var(--form-group-template-columns, ' +
    (props.groupTemplateColumns || 'unset') +
    ')'
  "
  [style.rowGap]="
    'var(--isp-dynamic-form__field-row-gap, ' + (props.rowGap || '25px') + ')'
  "
  [style.columnGap]="
    'var(--isp-dynamic-form__field-column-gap, ' +
    (props.columnGap || '20px') +
    ')'
  "
>
  <formly-field
    *ngFor="let field of field.fieldGroup"
    [field]="field"
    [style]="field.props?.style"
    class="group-item"
  ></formly-field>
</div>
